export function ignoreOldBrowser(ua: string): boolean {
  // Android は 9 以下除外
  // Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Mobile Safari/537.36
  const android = /Android (\d+)/.exec(ua)
  if (android && android[1] && parseInt(android[1], 10) <= 9) {
    return true
  }

  // Chrome (not on IOS) は user agent 文字列に Safari が含まれるので Safari チェック後に除外
  // Mozilla/5.0 (Macintosh; Intel Mac OS X 14_0_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/117.0.5938.92 Safari/537.36
  // Chrome on iOS の user-agent は "Chrome" を含まず CriOS となる
  // Mozilla/5.0 (iPad; CPU OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/1.0.7.0 Mobile/15E148 Safari/605.1
  if (ua.includes('Chrome')) {
    return false
  }

  // iOS, iPadOS は 14 以下除外
  // iOS の webview 系は Version が存在しないので iOS/iPad OS で判定
  // Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0 Mobile/15E148 Safari/604.1
  // Mozilla/5.0 (iPad; CPU OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/1.0.7.0 Mobile/15E148 Safari/605.1
  // Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 Safari Line/10.14.0
  const ios = /(?:iPhone OS|iPad; CPU OS) (\d+)_/.exec(ua)
  if (ios && ios[1] && parseInt(ios[1], 10) <= 14) {
    return true
  }

  // macOS の場合は version から取得
  // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0.2 Safari/605.1.15
  if (ua.includes('Mac OS X') && !ua.includes('iPhone') && !ua.includes('iPad')) {
    const mac = /Version\/(\d+)\./.exec(ua)
    if (mac && mac[1] && parseInt(mac[1], 10) <= 14) {
      return true
    }
  }

  return false
}

export function isUnsupportedIPhone(ua?: string): boolean {
  if (ua === undefined) {
    // SSR 時は何もしない
    if (typeof window === 'undefined') {
      return false
    }
    ua = window.navigator.userAgent
  }
  const version = iOSVersion(ua)
  if (version === undefined) {
    return false
  }
  const [major, minor] = version
  return major < 15 || (major === 15 && minor < 4) // 15.4 移行で Array.at 他多数の API が使えるようになる
}
if (import.meta.vitest) {
  const { describe, test, expect } = import.meta.vitest
  describe('ignoreOldBrowser', () => {
    test('15.2', () => {
      expect(
        isUnsupportedIPhone(
          'Mozilla/5.0 (iPhone; CPU iPhone OS 15_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.2 Mobile/15E148 Safari/604.1'
        )
      ).toBe(true)
    })
    test('15.2', () => {
      expect(
        isUnsupportedIPhone(
          'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.0.3 Mobile/15E148 Safari/605.1.15 Command/3.9.5'
        )
      ).toBe(false)
    })
  })
}

function iOSVersion(ua: string): [major: number, minor: number] | undefined {
  const ios = /(?:iPhone OS|iPad; CPU OS) (\d+)_(\d+)/.exec(ua)
  if (ios) {
    return [parseInt(ios[1], 10), parseInt(ios[2], 10)]
  }
}

if (import.meta.vitest) {
  const { describe, test, expect } = import.meta.vitest
  describe('iOSVersion', () => {
    test('15.0', () => {
      expect(
        iOSVersion(
          'Mozilla/5.0 (iPhone; CPU iPhone OS 15_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.0 Mobile/15E148 Safari/604.1'
        )
      ).toEqual([15, 0])
    })
    test('15.2', () => {
      expect(
        iOSVersion(
          'Mozilla/5.0 (iPhone; CPU iPhone OS 15_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.2 Mobile/15E148 Safari/604.1'
        )
      ).toEqual([15, 2])
    })
    test('15.8', () => {
      expect(
        iOSVersion(
          'Mozilla/5.0 (iPhone; CPU iPhone OS 15_8 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.6.6 Mobile/15E148 Safari/604.1'
        )
      ).toEqual([15, 8])
    })
    test('16.8.1', () => {
      expect(
        iOSVersion(
          'Mozilla/5.0 (iPhone; CPU iPhone OS 16_8_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.8.1 Mobile/15E148 Safari/604.1'
        )
      ).toEqual([16, 8])
    })
    test('17.0.3', () => {
      expect(
        iOSVersion(
          'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.0.3 Mobile/15E148 Safari/605.1.15 Command/3.9.5'
        )
      ).toEqual([17, 0])
    })
  })
}
